import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { LinkContainer, IfPermitted, Spinner } from "components/common";
import Routes from "routing/Routes";
import { MoreActions } from "components/common/EntityDataTable";
import RetrievalArchiveButton from "data-lake/data-lake-overview/actions/RetrievalArchiveButton";
import RetrievalArchiveModal from "data-lake/data-lake-overview/actions/RetrievalArchiveModal";
import DeleteArchiveModal from "data-lake/data-lake-overview/actions/DeleteArchiveModal";
import DeleteArchiveButton from "data-lake/data-lake-overview/actions/DeleteArchiveButton";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { LICENSE_SUBJECTS } from "license/constants";
import PreviewInternalLakeLogsButton from "data-lake/components/PreviewInternalLakeLogsButton";
const EntityActions = ({ archiveStreamId, streamTitle }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const {
    data: { valid: isValidLicense },
    isInitialLoading: isLoadingLicense
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  const [showRetrievalModal, setShowRetrievalModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const toggleRetrievalModal = () => setShowRetrievalModal((cur) => !cur);
  const toggleDeleteModal = () => setShowDeleteModal((cur) => !cur);
  const streamDeleted = streamTitle === null;
  const disabledTitle = streamDeleted ? t("entity_actions.stream_deleted") : void 0;
  if (isLoadingLicense) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isValidLicense && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PreviewInternalLakeLogsButton, { streamId: archiveStreamId }), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["data_lake_archive:restore"] }, /* @__PURE__ */ React.createElement(
    RetrievalArchiveButton,
    {
      onClick: toggleRetrievalModal,
      buttonType: "button",
      disabled: streamDeleted,
      title: disabledTitle
    }
  ))), /* @__PURE__ */ React.createElement(LinkContainer, { to: `${Routes.stream_view(archiveStreamId)}?segment=destinations` }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xsmall", disabled: streamDeleted, title: disabledTitle }, t("entity_actions.data_routing"))), isValidLicense && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["data_lake_archive:delete"] }, /* @__PURE__ */ React.createElement(MoreActions, null, /* @__PURE__ */ React.createElement(DeleteArchiveButton, { onClick: toggleDeleteModal }))), showRetrievalModal && /* @__PURE__ */ React.createElement(RetrievalArchiveModal, { archiveStreamId, onToggleModal: toggleRetrievalModal }), showDeleteModal && /* @__PURE__ */ React.createElement(DeleteArchiveModal, { archiveStreamId, onToggleModal: toggleDeleteModal }));
};
const useTableElements = () => {
  const entityActions = useCallback(
    (dataLake) => /* @__PURE__ */ React.createElement(EntityActions, { archiveStreamId: dataLake.stream_id, streamTitle: dataLake.stream_title }),
    []
  );
  return {
    entityActions
  };
};
export default useTableElements;
